export { default } from './error-boundary-message';
